export default "__VITE_ASSET__CIRRB_hz__"